module.exports = __webpack_public_path__ + "img/profess6.b5bc6cc2.png";